import React from 'react';
import styled from '@emotion/styled';
import { themeVars, Text, Box, Stepper } from '@eds-web/react';
import { stepConnectorClasses, StepConnector, StepLabel } from '@mui/material';

import { device } from '../../constants/breakpoint';
import { DIR } from '../../hooks/useLocale';

export const StyledMobilePrizeHeader = styled(Box)`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    margin-left: 24px;
`;

export const StyledColumn = styled(Text as React.ComponentType<any>)`
    flex: ${(props) => (props.$isEvent ? 2 : 1)};
    color: ${themeVars.color.transparent.light['065']};
    word-break: break-word;

    @media screen and ${device.laptop} {
        font-size: 12px;
    }

    @media screen and ${device.mobile} {
        display: none;
    }
`;

export const PrizeHeaderContent = styled(Text as React.ComponentType<any>)<{ $isEvent?: boolean }>`
    flex: ${(props) => (props.$isEvent ? 2 : 1)};
    max-height: 50px;
    overflow: hidden;
    p {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
    }
    ${(props) =>
        props.$isEvent &&
        `
    max-height: none;
    overflow: hidden;
    p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-wrap: break-word;
        word-break: break-word;
        line-clamp: 3;
    }
    `}

    @media screen and ${device.laptop} {
        font-size: 12px;
    }

    @media screen and ${device.mobile} {
        display: none;
    }
`;

export const FNLogoContent = styled.div`
    width: 99px !important;
    flex: 1;
    svg {
        width: 100%;
        height: 100%;
    }
    & .st0 {
        fill: #fff;
    }

    @media screen and ${device.laptop} {
        width: 80px;
    }

    @media screen and ${device.mobile} {
        width: 60px;
    }
`;

export const StyledPrizeProgressBar = styled(Box)`
    background-color: ${themeVars.color.background.elevated.low};
    padding: 32px;
    border-radius: 16px;
    width: 340px;
    margin: ${(props) => (props.$dir === DIR.LTR ? '0 32px 0 0' : '0 0 0 32px')};
    color: ${themeVars.color.transparent.light['065']};
    @media screen and ${device.laptop} {
        background-color: transparent;
        padding: 0;
        width: auto;
        margin-right: 0px;
    }
`;

export const StyledCurrentPrize = styled(Box)`
    flex: 1;
`;

export const StyledPrizeContainer = styled(Box)`
    gap: 16px;
    display: flex;
    flex-direction: column;
    p {
        color: ${themeVars.color.transparent.light['065']};
    }
    ul {
        margin: 0;
    }
    article {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    a {
        color: ${themeVars.color.foreground.accent};
    }
    @media screen and ${device.laptop} {
        button {
            width: 100%;
        }
    }
`;

export const StyledPrizeSteps = styled(Stepper)`
    @media screen and ${device.laptop} {
        display: none;
    }
`;

export const StyledMobilePrizeSteps = styled.div`
    display: none;
    @media screen and ${device.laptop} {
        display: flex;
        padding: 12px 0;
        background-color: ${themeVars.color.background.elevated.low};
        border: solid 1px ${themeVars.color.transparent.light['015']};
        border-radius: 24px;
        margin: 0 auto;
    }
`;

export const StyledStepLabel = styled(StepLabel)`
    cursor: pointer !important;

    &.${stepConnectorClasses.disabled} {
        cursor: default !important;

        svg {
            color: rgba(200, 200, 200, 0.2) !important;
        }
    }

    & .Mui-active {
        svg {
            color: rgb(250, 250, 250) !important;
        }
        .MuiStepIcon-text {
            fill: ${themeVars.color.transparent.dark['065']};
        }
    }

    & .Mui-completed {
        svg {
            color: ${themeVars.color.background.fill.success.primary};
        }
    }
    .MuiStepLabel-label.Mui-completed {
        color: ${themeVars.color.background.fill.success.primary} !important;
    }

    & .MuiStepLabel-label {
        color: ${themeVars.color.transparent.light['035']};
        &.Mui-active {
            color: ${themeVars.color.transparent.light['100']};
        }
    }
`;

export const StyledConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: `${themeVars.color.background.fill.success.primary}`
        }
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: `${themeVars.color.background.fill.success.primary}`
        }
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: `${themeVars.color.transparent.light['035']}`,
        borderTopWidth: 3,
        borderRadius: 1
    }
}));
